import { Heart } from "lucide-react";
import { useStore } from "@/store/StoreContext";

export const WishlistButton = ({ product, className = "", size = 18, testId }) => {
  const { wishlist, toggleWishlist } = useStore();
  const active = wishlist.includes(product.slug);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(product);
      }}
      aria-label={active ? "Hapus dari wishlist" : "Simpan ke wishlist"}
      className={`grid place-items-center transition-colors duration-300 ${
        active ? "text-sand" : "text-ink hover:text-sand"
      } ${className}`}
      data-testid={testId || `wishlist-toggle-${product.slug}`}
    >
      <Heart size={size} strokeWidth={1.5} fill={active ? "#A89680" : "none"} />
    </button>
  );
};
